module.exports = __webpack_public_path__ + "static/img/applet.0892634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applet.png
// module id = 6b4O
// module chunks = 20